import { IconIds } from '@jfs/ui-new'
import { statisticsType } from './data'

export const statsData = [
  {
    salesVolume: '₹1,47,100.49',
    numOfTransactions: 80,
    successRate: '80%',
    numOfRefunds: 10,
    numOfDisputes: 10,
    toolTip: 'Hi overview',
    type: statisticsType.Hourly,
  },
  {
    salesVolume: '₹1,47,111.49',
    numOfTransactions: 500,
    successRate: '85%',
    numOfRefunds: 100,
    numOfDisputes: 99,
    toolTip: 'Hi overview',

    type: statisticsType.Daily,
  },
  {
    salesVolume: '₹1,47,222.49',
    numOfTransactions: 1111,
    successRate: '80%',
    numOfRefunds: 444,
    numOfDisputes: 299,
    toolTip: 'Hi overview',

    type: statisticsType.Weekly,
  },
  {
    salesVolume: '₹1,47,444.49',
    numOfTransactions: 2222,
    successRate: '80%',
    numOfRefunds: 555,
    numOfDisputes: 333,
    toolTip: 'Hi overview',

    type: statisticsType.Monthly,
  },
  {
    salesVolume: '₹1,47,555.49',
    numOfTransactions: 33333,
    successRate: '80%',
    numOfRefunds: 1111,
    numOfDisputes: 555,
    toolTip: 'Hi overview',

    type: statisticsType.Yearly,
  },
  {
    salesVolume: '₹1,47,294.49',
    numOfTransactions: 8157,
    successRate: '80%',
    numOfRefunds: 1234,
    numOfDisputes: 10,
    toolTip: 'Hi overview',

    type: statisticsType.Date,
  },
]

export const balanceData = {
  pendingBalance: '₹1,467',
  lastSettleMent: '₹1,467',
}

export const holidayList = [
  '1/23/2020',
  '2/1/2020',
  '3/1/2020',
  '5/10/2020',
  '5/11/2020',
  '5/12/2020',
  '5/13/2020',
  '5/14/2020',
]

export const refundData: any = [
  {
    rrn: 'NA',
    transactionAmount: '0',
    refundAmount: '0',
    refundInitiatedDate: 'NA',
    refundStatus: 'NA',
   // refundDate: 'NA',
    arn: 'NA',
  },
]

export const notificationData = [
  {
    id: '1',
    value:
      'we have updated our privacy policy to clarify what information we collect, how we use it, and how we comply with applicable laws.',
    iconId: IconIds.USER,
    isRead: false,
  },
  {
    id: '2',
    value: 'You have new transactions',
    iconId: IconIds.ICON_REFRESH,
    isRead: true,
  },
  {
    id: '3',
    value: 'You have to settlements to do',
    iconId: IconIds.LOCK,
    isRead: false,
  },
]

export const fieldsSettingData = [
  {
    id: 'id',
    isChecked: true,
    title: 'id',
  },
  {
    id: 'date',
    isChecked: true,
    title: 'TXN DATE',
  },
  {
    id: 'ERN',
    isChecked: true,
    title: 'ERN',
  },
  {
    id: 'RRN',
    isChecked: true,
    title: 'RRN',
  },
  {
    id: 'totalAmount',
    isChecked: true,
    title: 'TXN AMT',
  },
  {
    id: 'transactionStatus',
    isChecked: true,
    title: 'TXN STATUS',
  },
  {
    id: 'paymentMode',
    isChecked: true,
    title: 'PAYMENT MODE',
  },
  {
    id: 'paymentType',
    isChecked: true,
    title: 'PAYMENT TYPE',
  },
  {
    id: 'bankRefNo',
    isChecked: true,
    title: 'BANK REF No',
  },
  {
    id: 'transactionType',
    isChecked: false,
    title: 'TXN TYPE',
  },
  {
    id: 'settlementReferenceNumber',
    isChecked: false,
    title: 'SETTLEMENT REF NO',
  },
  {
    id: 'accountNumber',
    isChecked: false,
    title: 'ACCOUNT NUMBER',
  },
  {
    id: 'refundAmount',
    isChecked: false,
    title: 'REFUND AMT',
  },
  {
    id: 'authCode',
    isChecked: false,
    title: 'AUTH CODE',
  },
  {
    id: 'acquirerTerminal',
    isChecked: false,
    title: 'ACQ TERMINAL',
  },
  {
    id: 'surCharge',
    isChecked: false,
    title: 'SURCHARGE AMT',
  },
  {
    id: 'convenienceFeeAmount',
    isChecked: false,
    title: 'CONVENIENCE FEE AMT',
  },
  {
    id: 'emiCode',
    isChecked: false,
    title: 'EMI CODE',
  },
  {
    id: 'merchantName',
    isChecked: false,
    title: 'MERCHANT NAME',
  },
  {
    id: 'merchantType',
    isChecked: false,
    title: 'MERCHANT TYPE',
  },
  {
    id: 'settlementStatus',
    isChecked: false,
    title: 'SETTLEMENT STATUS',
  },
  {
    id: 'chargeBackReason',
    isChecked: false,
    title: 'CHARGEBACK CODE',
  },
  {
    id: 'refundStatus',
    isChecked: false,
    title: 'REFUND STATUS',
  },
  {
    id: 'settlementDate',
    isChecked: false,
    title: 'SETTLEMENT DATE',
  },
  {
    id: 'customerId',
    isChecked: false,
    title: 'CUSTOMER ID',
  },
  {
    id: 'customerName',
    isChecked: false,
    title: 'CUSTOMER NAME',
  },
  {
    id: 'mobileNumber',
    isChecked: false,
    title: 'MOBILE NO.',
  },
  {
    id: 'email',
    isChecked: false,
    title: 'EMAIL',
  },
]
